import { useTranslation } from "hhn-commons";
import AlertHeaderWithDivider from "./AlertHeaderWithDivider";
import AlertsPanelHeader from "./AlertsPanelHeader";

const PriorityAlertHeader = ({ counter }: { counter: number }) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });
  return (
    <AlertHeaderWithDivider>
      <AlertsPanelHeader
        alertLabel={tNs("alerts.priority")}
        counter={counter}
      />
    </AlertHeaderWithDivider>
  );
};

export default PriorityAlertHeader;
